import React, {useEffect, useState} from "react";
import {Route, Switch, useRouteMatch} from "react-router-dom";
import foodbg from "../../assets/img/FoodBG.svg";
import ApiConnect from "../../Utils/ApiConnect";
import {safeLocalStorage} from "../../Utils/storage";
import CopyrightFooter from "../Components/CopyrightFooter";
import Error404 from "../Components/Error404";
import Headers from "../Components/Headers";
import Sidebar from "../Components/Sidebar";
import Module from "../Module";
import General from "./Pages/General";

function Dashboard(props) {
  const { url } = useRouteMatch(); 
  const [menuItems, setMenuItems] = useState([]);
  const [sidebar, setSidebar] = useState(false);
  const [compsort, setCompsort] = useState([]);
  const [sortMenu, SetSortMenu] = useState([]);
  useEffect(() => {
    safeLocalStorage.removeItem("AutoLoginTry");
    FetchMenu(); 
  }, []); 
  function getModules(menu, block, props) {
    if (typeof Module[menu][block] !== "undefined") {
      return React.createElement(Module[menu][block], props);
    }
    return React.createElement(() => <Error404 />, props);
  }

  function FetchMenu() {
    ApiConnect.get("Dashboard/UserPermission/MenuPermission")
      .then((response) => {
        if (response.data) {
          setMenuItems(response.data);
          let data = [];
          let modl = [];
          response.data.map((sub) => {
            modl.push(sub.name);
            sub.submenu.map((comp) => {
              let temp = {
                id: "1",
                short_code: comp.short_code || false,
                module: sub.name.replace(/[.*+?^${}()&;|[\]\\|\s]/g, ""),
                component: comp.name
                  .replace(/[.*+?^${}()&;|[\]\\|\s]/g, "")
                  .replace("&", ""),
                permission: comp.permission,
              };
              data.push({ ...temp });
            });
          });
          SetSortMenu(modl);
          setCompsort(data);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }
  function toggleSidebar() {
    setSidebar(!sidebar);
  }
  useEffect(() => {
    const rootElement = document.getElementById("root");
    if (!sidebar) {
      rootElement.classList.add("sidebar-folded");
    } else {
      rootElement.classList.remove("sidebar-folded");
    }
  }, [sidebar]);
  return (
    <div style={{ backgroundImage: `url(${foodbg})` }}>
      <Sidebar
        MenuDetails={menuItems}
        sidebarView={sidebar}
        sidebarToggle={toggleSidebar}
      />
      <Headers Layout="Dashboard" sidebarToggle={toggleSidebar} />
      <main className={`main-container pt-60 `}>
        <div className="main-content">
          <Switch>
            <Route path={url} exact component={General} />
            {compsort
              ? compsort.map((sub, subindex) => (
                  <Route
                    path={`${url}/${sub.module}/${sub.component}`}
                    key={subindex}
                    permission={sub.permission}
                  >
                    {getModules(sub.module, sub.component, props)}
                  </Route>
                ))
              : ""}
            <Route path="*">
              <Error404 />
            </Route>
          </Switch>
          <CopyrightFooter />
        </div>
      </main>
    </div>
  );
}
export default React.memo(Dashboard);
